<template>
    <b-modal
        id="modal-trace-cost"
        ref="trace-data" 
        size="xl"
        dialog-class="sx-modal-xl"  
        ok-only 
        ok-title="Cerrar" 
        title="Detalles cálculo de costo proveedor">

        <!-- Show loading -->
        <div v-if="loading" class="col-12 text-center py-4">
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
        </div>
        <!-- End show loading -->

        <section v-if="!loading">
            <b-tabs content-class="mt-3" fill>
                <b-tab title="Principal" active>
                    <!-- Tabla -->
                    <div class="table-section mb-3">
                        <div class="table-container">
                            <b-table
                                responsive
                                stacked="sm"
                                show-empty
                                small
                                hover
                                striped
                                bordered
                                selectable
                                select-mode="single"
                                @row-selected="onRowSelected"
                                :items="trace.items"
                                :fields="trace.columns"
                                :filter="trace.filter">
                                <template #cell(travelWindow)="row">
                                    <div v-if="row.item.ratePlanModel">
                                        <div v-if="row.item.ratePlanModel.travelWindowStartDate && row.item.ratePlanModel.travelWindowEndDate" class="text-nowrap">
                                            <md-icon icon="date_range" class="small-icon text-muted"></md-icon>
                                            <small>{{ formatDate(row.item.ratePlanModel.travelWindowStartDate) }}</small>
                                            <br>
                                            <small class="ml-3">{{ formatDate(row.item.ratePlanModel.travelWindowEndDate) }}</small>
                                        </div>
                                        <small v-else class="text-muted">-</small>
                                    </div>
                                    <small v-else class="text-muted">-</small>
                                </template>

                                <template #cell(serviceTime)="row">
                                    <div v-if="row.item.ratePlanModel">
                                        <div v-if="row.item.ratePlanModel.serviceStartTime && row.item.ratePlanModel.serviceEndTime" class="text-nowrap">
                                            <md-icon icon="schedule" class="small-icon text-muted"></md-icon>
                                            <small>{{ formatTime(row.item.ratePlanModel.serviceStartTime) }}</small>
                                            -
                                            <small>{{ formatTime(row.item.ratePlanModel.serviceEndTime) }}</small>
                                        </div>
                                        <small v-else class="text-muted">-</small>
                                    </div>
                                    <small v-else class="text-muted">-</small>
                                </template>

                                <template #cell(ratePlanId)="row">
                                    <a
                                        :href="'/rate-plans-edit?id='+row.item.ratePlanId"
                                        class="btn btn-sm btn-warning"
                                        target="__blank"
                                        v-if="$hasPermission('prices.show')">
                                        <md-icon icon="attach_money"></md-icon>
                                    </a>
                                </template>
                            </b-table>
                        </div>
                    </div>

                    <!-- Mapa - Siempre visible -->
                    <div class="map-section" v-if="selectedRow">
                        <div class="map-container">
                            <div class="map-header">
                                <h6 class="mb-0">
                                    <md-icon icon="map" class="mr-2"></md-icon>
                                    Mapa de Zonas - {{ selectedRow.ride }}
                                </h6>
                            </div>
                            <div class="map-details">
                                <b-row>
                                    <b-col cols="12" md="4">
                                        <div class="detail-item mb-3">
                                            <small class="text-muted">Plan Tarifario:</small>
                                            <div class="font-weight-bold">{{ selectedRow.ratePlan }}</div>
                                        </div>
                                        <div class="detail-item">
                                            <small class="text-muted">Zona Origen → Destino:</small>
                                            <div>{{ selectedRow.zoneFrom }} → {{ selectedRow.zoneTo }}</div>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <div class="detail-item mb-3">
                                            <small class="text-muted">
                                                <md-icon icon="event" class="small-icon mr-1"></md-icon>
                                                Fechas de Asignación:
                                            </small>
                                            <div v-if="selectedRow.ratePlanStartDate && selectedRow.ratePlanEndDate">
                                                {{ formatDate(selectedRow.ratePlanStartDate) }}
                                                -
                                                {{ formatDate(selectedRow.ratePlanEndDate) }}
                                            </div>
                                            <div v-else class="text-muted">-</div>
                                        </div>
                                        <div class="detail-item" v-if="selectedRow.ratePlanModel && selectedRow.ratePlanModel.travelWindowStartDate && selectedRow.ratePlanModel.travelWindowEndDate">
                                            <small class="text-muted">
                                                <md-icon icon="date_range" class="small-icon mr-1"></md-icon>
                                                Travel Window:
                                            </small>
                                            <div>
                                                {{ formatDate(selectedRow.ratePlanModel.travelWindowStartDate) }}
                                                -
                                                {{ formatDate(selectedRow.ratePlanModel.travelWindowEndDate) }}
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <div class="detail-item mb-3">
                                            <small class="text-muted">Servicio Venta:</small>
                                            <div>{{ selectedRow.service }}</div>
                                        </div>
                                        <div class="detail-item" v-if="selectedRow.ratePlanModel && selectedRow.ratePlanModel.serviceStartTime && selectedRow.ratePlanModel.serviceEndTime">
                                            <small class="text-muted">
                                                <md-icon icon="schedule" class="small-icon mr-1"></md-icon>
                                                Horario Servicio:
                                            </small>
                                            <div>
                                                {{ formatTime(selectedRow.ratePlanModel.serviceStartTime) }} - {{ formatTime(selectedRow.ratePlanModel.serviceEndTime) }}
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                            <GeoDetailsRide :geoDetails="getGeoDetails(selectedRow)"></GeoDetailsRide>
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Promociones" v-if="tracePromotion.lenght > 0">
                    <div class="d-flex w-100 flex-column mx-2">
                        <h4>Promociones</h4>
                        <TracePromotion :tracePromotion="tracePromotion"></TracePromotion>
                    </div>
                </b-tab>
            </b-tabs>
        </section>
    </b-modal>
</template>

<script>
import GeoDetailsRide from '../helpers/LeafletMap.vue'
import TracePromotion from '../helpers/TracePromo.vue'

export default {
    name: "TrackingSupplierCosts",
    components: {GeoDetailsRide, TracePromotion},
    props: {
        supplierId:{
            type: Number,
            required: false,
            default: -1
        },
        supplierServiceTypeId: {
            type: Number,
            required: false,
            default: -1
        }
    },
    data() {
        let columnsTrace = [
			{key:'ride',label:'Ride'},
			{key:'ratePlan',label:'Rate plan'},
			//{key:'ratePlanStartDate',label:'F. Asignación Inicio'},
			//{key:'ratePlanEndDate',label:'F. Asignación Fin'},
			//{key:'travelWindow',label:'Travel Window'},
			//{key:'serviceTime',label:'Horario Servicio'},
			{key:'zoneFrom',label:'Zona origen'},
			{key:'zoneTo',label:'Zona destino'},
			{key:'service',label:'Servicio venta'},
			{key:'supplierServiceType',label:'Servicio prov.'},
			{key:'msj',label:'Msj'},
			{key:'ratePlanId',label:'link'},
		]

        return {
            loading: false,
            serviceId: -1,
            trace: {
                filter: "",
                items: [],
                lastCalculated: -1,
                columns: columnsTrace
            },
			tracePromotion: [],
			selectedRow: null,
        }
    },
    methods: {
        showTrackingCosts(serviceId) {

            this.loading = true
            this.serviceId = serviceId
            this.tracePromotion = [];
			this.trace.items = [];
			this.selectedRow = null;

            this.$root.api
				.get(`/rates/supplier-prices/${this.serviceId}`, {
                    params: {
                        supplierId: this.supplierId,
                        supplierServiceTypeId: this.supplierServiceTypeId
                    }}
                )
				.then(res => {
                    this.loading = false;
                    this.trace.lastCalculated = this.serviceId
                    this.trace.items          = res.data.trace??[]
                    this.trace.items          = this.trace.items.map(v => ({...v, _showDetails: true}))
                    this.tracePromotion       = res.data.tracePromotion??[]

                    // Seleccionar la primera fila automáticamente si hay datos
                    if (this.trace.items.length > 0) {
                        this.selectedRow = this.trace.items[0];
                    }

                    this.$refs['trace-data'].show();
				})
				.catch(err => {
                    this.loading = false;
					if(err.response.data.trace) this.trace.items = [...err.response.data.trace];
                    // Seleccionar la primera fila automáticamente si hay datos
                    if (this.trace.items.length > 0) {
                        this.selectedRow = this.trace.items[0];
                    }
					this.$root.showAlert("No se encontró el precio", { variant: "danger" });

				}).finally(()=>{
					this.trace.lastCalculated = this.serviceId
				})

            this.$refs['trace-data'].show()
        },
		selectRowForMap(item) {
			this.selectedRow = item;
		},
		onRowSelected(items) {
			if (items.length > 0) {
				this.selectedRow = items[0];
			} else {
				this.selectedRow = null;
			}
		},
        getGeoDetails(row) {
			try {
				return [row.supplierGeoDetails]
			} catch(err) {
				console.log(err)
			}

			return [];
		},
        formatDate(dateString) {
            if (!dateString) return '';
            if (dateString == 'Not set') return '';
            try {
                const date = new Date(dateString);
                const options = { year: 'numeric', month: 'short', day: '2-digit' };
                return date.toLocaleDateString('es-ES', options);
            } catch (error) {
                return dateString;
            }
        },
        formatTime(timeString) {
            if (!timeString) return '';
            try {
                const timeParts = timeString.split(':');
                if (timeParts.length >= 2) {
                    return `${timeParts[0]}:${timeParts[1]}`;
                }
                return timeString;
            } catch (error) {
                return timeString;
            }
        }
    },
}
</script>

<style scoped>
	.small-icon {
		font-size: 14px;
		vertical-align: middle;
	}

	.text-nowrap {
		white-space: nowrap;
	}

	.table-section {
		width: 100%;
	}

	.table-container {
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		background: #fff;
		border-radius: 0.25rem;
	}

	.map-section {
		width: 100%;
		margin-top: 1.5rem;
	}

	.map-container {
		background: #fff;
		border-radius: 0.25rem;
		border: 1px solid #dee2e6;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.map-header {
		padding: 1rem 1.25rem;
		background-color: #f8f9fa;
		border-bottom: 2px solid #dee2e6;
	}

	.map-header h6 {
		margin: 0;
		font-size: 1rem;
		font-weight: 600;
		display: flex;
		align-items: center;
		color: #495057;
	}

	.map-details {
		padding: 1rem 1.25rem;
		background-color: #f8f9fa;
		border-bottom: 1px solid #dee2e6;
	}

	.detail-item {
		margin-bottom: 0;
	}

	.detail-item small {
		display: block;
		color: #6c757d;
		font-size: 0.75rem;
		margin-bottom: 0.25rem;
	}

	.detail-item .font-weight-bold {
		font-size: 0.9rem;
		color: #212529;
	}

	.detail-item div:not(.font-weight-bold) {
		font-size: 0.9rem;
		color: #495057;
	}

	@media (max-width: 768px) {
		.map-header {
			padding: 0.75rem 1rem;
		}

		.map-details {
			padding: 0.75rem 1rem;
		}

		.map-header h6 {
			font-size: 0.9rem;
		}
	}
</style>

<style>
	#modal-trace-cost .modal-dialog{
		width: 98% !important;
		max-width: inherit;
		margin: 0.5rem auto;
	}

	#modal-trace-cost .modal-content {
		overflow: hidden;
	}

	#modal-trace-cost .modal-body {
		padding: 0.5rem;
		overflow-x: hidden;
	}

	@media (min-width: 1200px){
		#modal-trace-cost .modal-dialog{
			max-width: 95%;
			margin: 1rem auto;
		}

		#modal-trace-cost .table{
			font-size: .85rem;
		}
	}

	@media (min-width: 1400px){
		#modal-trace-cost .modal-dialog{
			max-width: 1380px;
		}
	}

	#modal-trace-cost .table {
		margin-bottom: 0;
		width: 100%;
	}

	#modal-trace-cost .table td {
		vertical-align: middle;
		padding: 0.5rem 0.4rem;
		font-size: 0.85rem;
		max-width: 250px;
		word-wrap: break-word;
	}

	#modal-trace-cost .table th {
		background-color: #f8f9fa;
		font-weight: 600;
		font-size: 0.75rem;
		padding: 0.6rem 0.4rem;
		border-bottom: 2px solid #dee2e6;
		white-space: nowrap;
		position: sticky;
		top: 0;
		z-index: 10;
	}

	#modal-trace-cost .table-striped tbody tr:nth-of-type(odd) {
		background-color: rgba(0,0,0,.02);
	}

	#modal-trace-cost .table-hover tbody tr:hover {
		background-color: rgba(0,0,0,.04);
	}

	#modal-trace-cost .btn-sm {
		padding: 0.25rem 0.5rem;
		font-size: 0.75rem;
	}

	#modal-trace-cost small {
		font-size: 0.8rem;
		line-height: 1.4;
	}

	/* Ajustes para el mapa en row-details */
	#modal-trace-cost .card {
		max-width: 100%;
		overflow: hidden;
	}

	/* Asegurar que la tabla responsive funcione correctamente */
	#modal-trace-cost .table-responsive {
		display: block;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}

	/* Tabs */
	#modal-trace-cost .nav-pills {
		margin-bottom: 0;
	}
</style>
